import { render, staticRenderFns } from "./_broadcast.vue?vue&type=template&id=78a8ed13&scoped=true&"
import script from "./_broadcast.vue?vue&type=script&lang=js&"
export * from "./_broadcast.vue?vue&type=script&lang=js&"
import style0 from "./_broadcast.vue?vue&type=style&index=0&id=78a8ed13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a8ed13",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeroRadioVideo: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/hero/RadioVideo.vue').default,IconsArrowRight: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/ArrowRight.vue').default,RadioCarouselItem: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/radio/CarouselItem.vue').default,RadioCarousel: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/radio/Carousel.vue').default})
